<template>
  <b-modal
    ref="configurationWorkDaysModal"
    centered
    modal-class="configuration-workdays-modal"
    :title="$t('configuration.modal.calendar.workDays')"
    @hidden="hide"
  >
    <b-container fluid>
      <b-row>
        <b-col class="d-flex align-items-center justify-content-center">
          <div class="d-flex flex-column align-items-center justify-content-center">
            <div class="calendar-icon">
              <calendar />
            </div>
            <div class="mt-3 text-center">
              <span class="dark">{{ $t('configuration.modal.calendar.workDaysTitle') }}</span><br>
              <small>{{ $t('configuration.modal.calendar.workDaysSubtitle') }}</small>
            </div>
          </div>
        </b-col>
        <b-col
          cols="4"
          class="bordered-column p-3"
        >
          <ul class="p-2">
            <li
              v-for="day in daysOfWeek"
              :key="day.id"
            >
              <b-form-checkbox v-model="day.selected">
                {{ $t(day.translatedName) }}
              </b-form-checkbox>
            </li>
          </ul>
        </b-col>
      </b-row>
    </b-container>
    <div
      slot="modal-footer"
      class="footer-banner px-2"
      style="width:100%;"
    >
      <div class="row">
        <div class="col-auto text-left">
          <b-button
            size="sm"
            variant="outline-secondary"
            data-dismiss="modal"
            @click="hide"
          >
            {{ $t('global.cancel') }}
          </b-button>
        </div>
        <div class="col text-right">
          <b-button
            size="sm"
            class="btn--primary"
            @click="apply"
          >
            <i
              class="fal fa-check mr-2"
              aria-hidden="true"
            />
            {{ $t('global.apply') }}
          </b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import Calendar from '@/assets/images/svg/Calendar'
import { DAY_OF_WEEK } from '@/api/resources/personnelEvents/constants/dayOfWeek'

export default {
    name: 'ConfigurationWorkDaysModal',
    components: { Calendar },
    props: {
        actionTitle: String
    },
    data() {
        return {
            daysOfWeek: []
        }
    },
    methods: {
        show(daysOfWeekForWeekendDays) {
            this.$_cleanComponentData()
            if (daysOfWeekForWeekendDays) {
                this.setDaysOfWeek(daysOfWeekForWeekendDays)
            }
            this.$refs.configurationWorkDaysModal.show()
        },
        apply() {
            this.$emit('updateLaboratoryWeekendDays', this.daysOfWeek)
            this.hide()
        },
        setDaysOfWeek(daysOfWeekForWeekendDays) {
            this.daysOfWeek = Object.values(DAY_OF_WEEK)
            for (let weekendDay of this.daysOfWeek) {
                weekendDay.translatedName = DAY_OF_WEEK[weekendDay.code].translatedName
                const selectedDayArrayPosition = daysOfWeekForWeekendDays.find(dayOfWeekForWeekendDay => dayOfWeekForWeekendDay === weekendDay.arrayPosition)
                if (selectedDayArrayPosition >= 0) {
                    weekendDay.selected = true
                }
            }
        },
        hide() {
            this.$refs.configurationWorkDaysModal.hide()
        }
    }
}
</script>

<style lang="scss">
    .configuration-workdays-modal .modal-body {
        padding: 0;
    }
    .configuration-workdays-modal .bordered-column {
        border-left: 1px solid vt-color(general-border);
    }
    .configuration-workdays-modal ul li {
        list-style: none;
        margin: 5px 0;
        color: vt-color(dark-text);
    }
    .configuration-workdays-modal ul{
        margin: 0;
        padding: 0;
    }
    .configuration-workdays-modal .calendar-icon {
        width: 100px;
    }
</style>
